"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Repeater = exports._Repeater = void 0;
var react_1 = __importDefault(require("react"));
var react_feather_1 = require("react-feather");
var label_1 = require("../label");
var use_create_repeater_1 = require("./use-create-repeater");
var _Repeater = function (_a) {
    var children = _a.children, description = _a.description, data = _a.data, renderer = _a.renderer, dataTestId = _a["data-testid"], formManager = _a.formManager, name = _a.name, repetitionSingularTitle = _a.repetitionSingularTitle, form = _a.form;
    var repeater = (0, use_create_repeater_1.useCreateRepeater)(repetitionSingularTitle, {
        initialData: data,
        renderer: renderer,
        formManager: formManager,
        name: name,
        form: form,
    });
    return (react_1.default.createElement("div", { "data-testid": dataTestId, className: "w-full bg-white border rounded-md border-gray-200 p-4" },
        react_1.default.createElement("div", { className: "mb-4 flex justify-between" },
            react_1.default.createElement("div", { className: "-mt-2 " },
                react_1.default.createElement(label_1.Label, { style: { paddingLeft: 0, backgroundColor: "transparent" }, isFocused: true, className: "fs16 font-body font-bold leading-snug" }, children),
                description && react_1.default.createElement("p", { className: "fs14 mt-1" }, description)),
            react_1.default.createElement("p", { className: "fs12 text-gray-400 whitespace-nowrap" },
                repeater.repetitions.length,
                " ",
                repeater.repetitions.length === 1 ? "item" : "items")),
        repeater.repetitions.length > 0 ? (repeater.repetitions.map(function (repetition, i) {
            return (react_1.default.createElement("div", { key: "rep-" + i + "-of-" + repeater.repetitions.length, className: "bg-gray-100 p-3 mb-3 rounded-md" },
                react_1.default.createElement(RepetitionHeading, { repeater: repeater, index: i }),
                react_1.default.createElement("div", null, repeater.render(repetition, repeater.getRepetitionFormData(i)))));
        })) : (react_1.default.createElement("div", { className: "bg-gray-100 p-3 mb-3 rounded-md" },
            react_1.default.createElement("p", { className: "text-center text-gray-400" }, "Add your first item"))),
        react_1.default.createElement("div", { className: "flex justify-center mt-4" },
            react_1.default.createElement("button", { type: "button", className: "flex text-white font-bold bg-visto hover:bg-gray-600 active:bg-gray-200 disabled:bg-opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none rounded-3xl justify-center items-center  px-6 py-2 fs14 ", onClick: function () {
                    repeater.add();
                } }, "Add Item"))));
};
exports._Repeater = _Repeater;
function RepetitionHeading(_a) {
    var repeater = _a.repeater, index = _a.index;
    var isFirst = index === 0;
    var isLast = repeater.repetitions.length === index + 1;
    return (react_1.default.createElement("div", { className: "w-full flex justify-between items-start mb-3" },
        react_1.default.createElement("p", { className: "fs14 font-semibold" }, repeater.getHeading(index)),
        react_1.default.createElement("div", { className: "flex items-center" },
            !isFirst && (react_1.default.createElement("button", { className: "fs12 text-right text-gray-400 hover:text-gray-800", type: "button", onClick: function () { return repeater.move(index, "UP"); } },
                react_1.default.createElement(react_feather_1.ArrowUp, { size: 16 }))),
            !isLast && (react_1.default.createElement("button", { className: "fs12 text-right text-gray-400 hover:text-gray-800", type: "button", onClick: function () { return repeater.move(index, "DOWN"); } },
                react_1.default.createElement(react_feather_1.ArrowDown, { size: 16 }))),
            react_1.default.createElement("button", { className: "fs12 text-right text-gray-400 hover:text-gray-800 ml-2", type: "button", onClick: function () {
                    if (confirm("Are you sure you want to delete this item?")) {
                        repeater.remove(index);
                    }
                } },
                react_1.default.createElement(react_feather_1.Trash2, { size: 16 })))));
}
var Repeater = function (_a) {
    var formManager = _a.formManager, name = _a.name, form = _a.form, props = __rest(_a, ["formManager", "name", "form"]);
    return (react_1.default.createElement(exports._Repeater, __assign({ data: formManager._initialData, formManager: formManager, name: name, form: form }, props)));
};
exports.Repeater = Repeater;
